import React from 'react';
import { useFormContext } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import strings from 'strings';

import { FORM_FIELDS_MAP } from '../../drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import { ReminderCard } from '../../shared';

const COPIES = strings.sendoutsV2.form.sections.emailReminders;

export const EmailRemindersFields = ({
  candidateName = COPIES.placeholders.candidate,
  hiringAuthorityName = COPIES.placeholders.hiringAuthority,
  url = null
}) => {
  const { control } = useFormContext();

  return (
    <Box display="flex" flexDirection="column" gridGap={16} width="100%">
      <ReminderCard
        candidateFieldName={FORM_FIELDS_MAP.CandidateTwentyFourHoursReminder.key}
        candidateName={candidateName}
        control={control}
        hiringAuthorityFieldName={FORM_FIELDS_MAP.HiringAuthorityTwentyFourHoursReminder.key}
        hiringAuthorityName={hiringAuthorityName}
        title={COPIES.labels.twentyFourHours}
        url={url}
      />
      <ReminderCard
        candidateFieldName={FORM_FIELDS_MAP.CandidateOneHourReminder.key}
        candidateName={candidateName}
        control={control}
        hiringAuthorityFieldName={FORM_FIELDS_MAP.HiringAuthorityOneHourReminder.key}
        hiringAuthorityName={hiringAuthorityName}
        title={COPIES.labels.oneHour}
        url={url}
      />
    </Box>
  );
};
